import { useState, type JSX } from 'react';
import { Link } from 'react-router';

import styles from './styles.module.css';

export function ProviderTopbar(): JSX.Element {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <header className={styles.topbar}>
      <div className={styles.topbarRow}>
        <Link to="/" className={styles.logo} aria-label="NourishedRx home">
          {logoFailed ? (
            <span className={styles.logoText}>NourishedRx</span>
          ) : (
            <img src="/logo.png" alt="NourishedRx" onError={() => setLogoFailed(true)} />
          )}
        </Link>
        <div className={styles.topbarActions}>
          <span className={styles.providerLabel}>For Healthcare Providers</span>
          <Link to="/refer" className={`${styles.btn} ${styles.btnPrimary}`}>
            Submit a referral
          </Link>
        </div>
      </div>
    </header>
  );
}
